import apiClient from "@/shared/api/apiClient";

export const getUserDevices = async (params) => {
  try {
    const { data } = await apiClient.get("/user-devices/", { params });
    return data;
  } catch (e) {
    console.error("getUserDevices failed", e);
  }
};

export const updateUserDeviceStatus = async (devicePk, payload) => {
  const { data } = await apiClient.put(
    `/user-devices/${devicePk}/status/`,
    payload
  );
  return data;
};
